import { z } from 'zod';
import { MIN_CAMERA_ANGLE, MAX_CAMERA_ANGLE } from './camera-angle.js';

/** Shared bounds for saved drafts, local requests, the API, and queued renders. */
export const CameraAngleSchema = z.number().min(MIN_CAMERA_ANGLE).max(MAX_CAMERA_ANGLE);
